import { render, staticRenderFns } from "./PopupEdit.vue?vue&type=template&id=d47d36c8"
import script from "./PopupEdit.vue?vue&type=script&lang=js"
export * from "./PopupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports